import { createApi } from "@reduxjs/toolkit/query/react";
import { ElpResponseProps } from "@src/app/elpQuestionSlice";
import {
  SubmissionAPIResponse,
  SubmissionResponse,
} from "@src/pages/student/elp/types";
import { baseQueryWithReauth } from "@src/utils/baseQuery";
import { APIResponse } from "./CommonApiSlice";

export interface StudentEvaluationPayload {
  questionId: string;
  userId: string;
  batchId: string;
  totalScore: number;
  remarks: string;
}

export interface StudentEvaluationResponse extends APIResponse {
  response: string;
}

export const ElpAnswerSubmissionApiSlice = createApi({
  reducerPath: "elpAnswerSubmissionApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    submitElpAnswer: builder.mutation<
      { httpStatus: string; statusCode: number; response: SubmissionResponse },
      { payload: ElpResponseProps | FormData }
    >({
      query: ({ payload }) => ({
        url: `execution/execute-assigned-questions`,
        method: "POST",
        body: payload,
      }),
    }),
    getAssignedQuestionSubmissionData: builder.query<
      SubmissionAPIResponse,
      { questionId: string; batchId: string; userId: string }
    >({
      query: ({ batchId, questionId, userId }) => {
        return {
          url: "assigned-questions",
          method: "GET",
          params: { questionId, batchId, ...(userId && { userId }) },
        };
      },
    }),
    sendEvaluation: builder.mutation<
      StudentEvaluationResponse,
      { payload: StudentEvaluationPayload }
    >({
      query: ({ payload }) => ({
        url: `assigned-questions`,
        method: "PUT",
        body: payload,
      }),
    }),
  }),
});

export const {
  useSubmitElpAnswerMutation,
  useLazyGetAssignedQuestionSubmissionDataQuery,
  useSendEvaluationMutation,
} = ElpAnswerSubmissionApiSlice;
